import { ElithairConfig } from "@elit-hair/brands";

export const ENV = {
    NODE_ENV: import.meta.env.PROD,
    ELITHAIR_API_URL: {
        v1: import.meta.env.VITE_ELITHAIR_API_URL || "https://dev-api.elithair.tech",
        v2: import.meta.env.VITE_ELITHAIR_SERVICES_URL || "https://svc.elithair.tech/api",
    },
    ZOHO_ELITHAIR_SSO_URL:
        import.meta.env.VITE_ZOHO_ELITHAIR_SSO_URL || "https://one.zoho.com/p/700227663/app/70704000002241001/sso",
    ZOHO_BIOHAIR_SSO_URL: import.meta.env.VITE_ZOHO_BIOHAIR_SSO_URL || "",
    ZOHO_BASE_URL: import.meta.env.VITE_ZOHO_BASE_URL || "https://svc.elithair.tech/api",
    RELEASE_VERSION: import.meta.env.VITE_RELEASE_VERSION,
    CLIENT_IDS: import.meta.env.VITE_CLIENT_IDS || ElithairConfig.zohoOrganizationId,
};
